import React from 'react';
import styled from 'styled-components';
import { Box, Text } from '@rsos/components/capstone/base';

export const BasePrimaryText = styled(Text).attrs({
  color: 'primaryText',
  size: 'normal',
})``;

export const AccordionContentRow = styled(BasePrimaryText)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 16px;
  margin-bottom: 16px;
  padding-top: 13px;
`;

export const AccordionSectionTitle = styled(Text).attrs({
  fontWeight: 'bold',
  color: 'primaryText',
  size: 'normal',
})``;

export const AccordionSectionSubTitle = styled(Text).attrs({
  fontWeight: 'semibold',
  color: 'primaryText',
  size: 'normal',
})``;
export const AccordionSectionDesc = styled(Text).attrs({
  color: 'secondaryText',
  size: 'small',
})``;

const getData = data => {
  return data ? data : 'N/A';
};
export const AccordionRowColumn = ({ title, data }) => {
  return (
    <Box>
      <Text size="small" color="secondaryText">
        {title}
      </Text>
      <Text size="large" color="primaryText">
        {getData(data)}
      </Text>
    </Box>
  );
};
